import type { LucideIcon } from "lucide-react";
import type { ButtonHTMLAttributes, ReactNode } from "react";

import styles from "../styles/App.module.css";

type CommandButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: LucideIcon;
  title: string;
  hint?: string;
  children?: ReactNode;
};

export function CommandButton({
  icon: Icon,
  title,
  hint,
  children,
  ...buttonProps
}: CommandButtonProps) {
  return (
    <button className={styles.commandButton} type="button" {...buttonProps}>
      <Icon aria-hidden="true" size={30} strokeWidth={2.4} />
      <span>
        <strong>{title}</strong>
        {hint ? <small>{hint}</small> : null}
        {children}
      </span>
    </button>
  );
}
